/**
 * Base class for all shared objects that extends the [`EventEmitter`](#eventemittertype) class.
 * The implementation is written in C++, installed through JSI and common for mobile platforms.
 */ export { };

//# sourceMappingURL=SharedObject.js.map
